// @flow
import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';

import { colors } from '../../../shared/styles';

import TextInput from './TextInput';

const StyledVideoInput = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & button {
        display: inline-block;
        color: ${colors.white};
        background: ${colors.orange.default};
        padding: 10px;
        border-radius: 4px;
        border: none;
    }

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .video {
        margin: 10px 0;
        padding-bottom: 10px;
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        text-align: center;
    }

    & .video label,
    & .video input {
        text-align: left;
    }
`;

const videoDefaultValue = {
    videoCode: '',
    videoTitle: '',
};

const VideoInput = (props: any) => {
    const { disabled, fields } = props;

    return (
        <StyledVideoInput>
            <div className="video-list">
                {fields.map((field, index) => {
                    return (
                        <div key={index} className="video">
                            <Field
                                name={`${field}.videoCode`}
                                label="Video Code"
                                component={TextInput}
                                disabled={disabled}
                            />

                            <Field
                                name={`${field}.videoTitle`}
                                label="Video Title"
                                component={TextInput}
                                disabled={disabled}
                            />

                            <button
                                type="button"
                                onClick={() => fields.remove(index)}
                            >
                                Remove
                            </button>
                        </div>
                    );
                })}
            </div>

            <button
                className="add-button"
                type="button"
                onClick={() => fields.push(videoDefaultValue)}
            >
                Add Video
            </button>
        </StyledVideoInput>
    );
};

export default VideoInput;



// WEBPACK FOOTER //
// ./src/components/shared/forms/VideoInput.js